import { render, staticRenderFns } from "./MyApplications.vue?vue&type=template&id=47f17c85&scoped=true"
import script from "./MyApplications.vue?vue&type=script&lang=js"
export * from "./MyApplications.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47f17c85",
  null
  
)

export default component.exports